export const gHeaderAcc = () => {
  const BP = 736;

  $("[data-acc-unit]").on({
    mouseenter: function () {
      if (window.innerWidth > BP) {
        $(this).attr("data-acc-unit", "open");
        $(this).find("[data-acc-contents]").stop().slideDown();
      }
    },
    mouseleave: function () {
      if (window.innerWidth > BP) {
        $(this).attr("data-acc-unit", "close");
        $(this).find("[data-acc-contents]").stop().slideUp();
      }
    },
  });

  $("[data-acc-unit] dt").on({
    click: function () {
      if (window.innerWidth <= BP) {
        if ($(this).parent()[0].dataset.accUnit === "open") {
          $(this).parent().attr("data-acc-unit", "close");
          $(this).parent().find("[data-acc-contents]").stop().slideUp();
        } else {
          $(this).parent().attr("data-acc-unit", "open");
          $(this).parent().find("[data-acc-contents]").stop().slideDown();
        }
      }
    },
  });
};
